import api from '../callApi';

const completeCall = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime: actionCompletedTime
    };

    return api.post('Widget/CompleteCallAsync', request).then(response => {
        return response;
    });
};

export default completeCall;
